require("data/widgets/widget_item.scss");

class WidgetItem extends React.Component {
  constructor(props) {
    super();
    autobind(this);
  }

  dividerColumn() {
    if (this.props.dividerColumn) {
      return (
        <div className="widgetItem-column divider-column"></div>
      )
    }
  }

  fontColorClass() {
    var { primaryMetric, font_color } = this.props

    if (!primaryMetric || primaryMetric.metric == 0) {
      return null
    }

    if (font_color) {
      return `fontColor-${font_color}`
    } else if (primaryMetric.statColor) {
      return `fontColor-${primaryMetric.statColor}`
    }
  }

  fontSizeClass() {
    var { primaryMetric } = this.props
    return primaryMetric ? `statSize-${primaryMetric.statSize}` : ''
  }

  renderLink() {
    var { link } = this.props
    if (link) {
      return link.expand_component ? <a className='hideOnPrint' onClick={link.location}>{link.text}</a> : <a className='hideOnPrint' href={link.location}>{link.text}</a>
    }
  }

  renderSubContent() {
    var { sublink, secondaryMetric, subtitle } = this.props

    if (sublink) {
      return <div><a href={sublink.location}>{sublink.text}</a></div>
    } else if (subtitle) {
      return <div className={`subtitle ${this.fontSizeClass()} ${this.fontColorClass()}`}>{subtitle}</div>
    } else if (secondaryMetric) {
      return <div className={`subtitle ${this.fontSizeClass()} ${this.fontColorClass()}`}>{secondaryMetric}</div>
    }
  }

  render() {
    var { icon, width, primaryMetric, title, lookup_key } = this.props
    
    // default icon
    icon = icon ? icon : 'books'
    
    var statText = ""
    if (primaryMetric){
     statText = primaryMetric.statText
    }
    
    return (
      <div className={`widgetItem width-${width}`}>
        <div className='widgetItem-table'>
          <div className={`widgetItem-column icon ${this.fontSizeClass()}`}>
            <img className='iconImage' src={require(`widget-icons/${icon}.png`)} />
          </div>
          <div className={`widgetItem-column stat ${lookup_key.replace(/ /g, '-') }-stat ${this.fontSizeClass()} ${this.fontColorClass()}`}>{statText}</div>
          <div className={`widgetItem-column text-column`}>
            <div className={`title ${this.fontColorClass()} ${this.fontSizeClass()}`}>{title}</div>
            {this.renderSubContent()}
            {this.renderLink()}
          </div>
          {this.dividerColumn()}
        </div>
      </div>
    )
  }
};

// WidgetItem.WrappedComponent.propTypes = PageStrictPropTypes({
// });

module.exports = WidgetItem;


// WEBPACK FOOTER //
// ./modules/components/data/widgets/helpers/WidgetItem.js